import { BodyText, FlexColumn, FlexRow, SvgIcon } from '@make-software/cspr-design';
import styled from 'styled-components';
import TelegramIcon from 'assets/icons/ic-telegram.svg';
import React from 'react';
import { SourceInfoWrapper } from 'app/components/common/common-styles';
import { truncateString } from 'app/components/utils/measures-format';

export interface TaskShortPreviewProps {
  name: string;
  description: string;
}

const TaskWrapper = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    minWidth: '300px',
    width: '100%'
  })
);

const IconWrapper = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    padding: '12px',
    backgroundColor: theme.styleguideColors.backgroundPrimary
  })
);

const StyledTitle = styled(BodyText)(({ theme }) =>
  theme.withMedia({
    display: 'block'
  })
);

const StyledDescription = styled.div(({ theme }) =>
  theme.withMedia({
    fontSize: '13px',
    display: 'block',
    lineHeight: '20px',
    width: ['150px', '200px', '100%'],
    whiteSpace: ['nowrap', 'nowrap', 'unset'],
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: theme.styleguideColors.contentSecondary
  })
);

export const TaskShortPreview = ({ name, description }: TaskShortPreviewProps) => {
  return (
    <TaskWrapper>
      <FlexRow>
        <SourceInfoWrapper justify={'flex-start'} align={'center'} gap={12}>
          <IconWrapper justify={'center'} align={'center'}>
            <SvgIcon src={TelegramIcon} size={28} />
          </IconWrapper>
          <div>
            <StyledTitle size={1}>{name}</StyledTitle>
            <StyledDescription>{truncateString(description, 100)}</StyledDescription>
          </div>
        </SourceInfoWrapper>
      </FlexRow>
    </TaskWrapper>
  );
};
